import React from 'react';
import classnames from 'classnames';
import { Swiper, SwiperSlide } from 'swiper/react';
import useIntersection from 'hooks/useIntersection';
import './styles.scss';

const ImgSwiper = ({ data }) => {
  const { scrollWrapper, inViewSec, inViewRefSec } = useIntersection({
    threshold: 0.5,
  });

  return (
    <div ref={scrollWrapper}>
      <div
        className={classnames(
          inViewSec && 'cr-anim-init',
          'cr-leadership-img-slider'
        )}
        ref={inViewRefSec}
      >
        <Swiper
          breakpoints={{
            1200: {
              slidesPerView: 3.5,
            },
            768: {
              slidesPerView: 2.75,
            },
            320: {
              slidesPerView: 1.25,
            },
          }}
          centeredSlides={true}
          loop="true"
        >
          {data.length &&
            data.map((slide, i) => {
              return (
                <SwiperSlide key={i}>
                  <div className="cr-leadership-img-slider__slide">
                    <img src={slide} alt="" />
                  </div>
                </SwiperSlide>
              );
            })}
        </Swiper>
      </div>
    </div>
  );
};

export default ImgSwiper;
